import { useListOrdersWithIssuesQuery } from './threads.api';

// Tab title for the Dashboard's "Probleme" tab. Reads the count off the
// shared RTK Query cache so it dedupes with the OrdersWithIssues widget's
// own fetch (one request feeds both).
export function ProblemsTabLabel() {
    const { data } = useListOrdersWithIssuesQuery(
        { page: 1, limit: 10 },
        { pollingInterval: 60000 },
    );

    const count = data?.pagination.totalCount ?? 0;

    return (
        <span>
            Probleme
            {count > 0 && (
                <span className="ml-1.5 inline-flex items-center rounded-full bg-red-100 px-1.5 py-0.5 text-xs font-semibold text-red-800 dark:bg-red-900/40 dark:text-red-300">
                    {count}
                </span>
            )}
        </span>
    );
}
